import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import IndexProduct from "@/pages/design/components/indexProduct";
import { request, METHOD } from "@/utils/request";
// const BASE_URL = process.env.VUE_APP_API;

import { mapState } from 'vuex';
import { designGetProductList } from '@/services/design';
export default {
  name: 'GoodsList',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    id: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    IndexProduct: IndexProduct
  },
  data: function data() {
    return {
      rootWidth: 0,
      defaultLangId: 0
    };
  },
  mounted: function mounted() {
    this.rootWidth = this.$refs.rootRef.clientWidth;
  },
  computed: {},
  created: function created() {
    var defaultLangObjStr = localStorage.cdefaultLangObj ? localStorage.cdefaultLangObj : localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }

    /*
    进来productList 为空 -> 请求
    进来productList 有数据 -> 不请求
    如果商品列表有数据  就不请求
    如果请求因为网络慢 productList赋值比较晚
    又在配置页面添加了数据  这时productList是有数据的
    有数据 就添加在后面
    切换语言导致的有数据 会一进来就有数据 那么就不请求了
    添加后的语言也是原来的语言 没有切换!!!!
    */

    // this.getProductList();
    // if (this.formData.productList.length == 0){
    //   this.getProductList();
    // }
  },
  methods: {
    getProductList: function getProductList() {
      var _this = this;
      designGetProductList({
        moduleId: this.id,
        langId: this.defaultLangId,
        plate: 2,
        clentType: 1
      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        // let arr = []
        // if (this.formData.addedProduct && this.formData.addedProduct.length > 0){
        //   arr = [...this.formData.addedProduct, ...res.data.productList]
        // }else {
        //   arr = res.data.productList
        // }
        //

        // this.$set(this.formData, "productList", arr);
        _this.$set(_this.formData, "productList", res.data.productList);
      }).catch(function (err) {
        console.log('getProductList err', err);
        _this.$set(_this.formData, "productList", []);
      });
    }
  }
};